export const getJWT = () => {
  return localStorage.getItem('jwt')
}
